import React , { useState, useEffect, useCallback} from "react";
import client from "../../client";
import { cleanUpAbout, cleanUpSlides, cleanUpCategories} from "./helpers";

export const Context = React.createContext()

export const Provider = (props) => {

    const [about, setAbout] = useState({})
    const [isAboutLoading, setIsAboutLoading] = useState(false)

    const [isCarouselLoading, setIsCarouselLoading] = useState(false)
    const [carouselSlides, setCarouselSlides] = useState([])

    const [categories, setCategories] = useState([])
    const [isCategoriesLoading, setIsCategoriesLoading] = useState(false)



    const savaAboutData = useCallback((rawData) =>{

        const cleanAboutData = cleanUpAbout(rawData)
        setAbout(cleanAboutData)
    }, [])

    const fetchAbout = useCallback (async () => {
        
        try {

            const response = await client.getEntry('3rL6RjyTLCRgPn2wY8N3Pv')
            // console.log(response)
            if (response) {
                savaAboutData(response)
                setIsAboutLoading(true)
            } else {
                setAbout({})
                setIsAboutLoading(false)
            }
            
        } 
        catch (error) {
            console.log(error)
            setIsAboutLoading(false)
        }
    },[savaAboutData])

    useEffect(() => {
      fetchAbout()
    }, [fetchAbout])

    const saveCarouselData = useCallback((rawData) => {
        const cleanCarouselData = cleanUpSlides(rawData)
        setCarouselSlides(cleanCarouselData)
    },[])

  
    const getCarosuelSlides = useCallback(async () => {

       
        try{
            const response = await client.getEntries({content_type:'recipeBoxCarousel'})
            const responseData = response.items
            console.log(responseData)
            if(responseData)
            {
                saveCarouselData(responseData)
                setIsCarouselLoading(true)
            }
            else{
                setCarouselSlides([])
                setIsCarouselLoading(false)
            }
        }
        catch(err){
            console.log(err)
            setIsCarouselLoading(false)
        }
    }, [saveCarouselData])

    useEffect(() => {

        getCarosuelSlides()

    },[getCarosuelSlides])

    const savaCategoryData = useCallback((rawData) =>{

        const cleanCategoryData = cleanUpCategories(rawData)
        setCategories(cleanCategoryData)
    }, [])

    const fetchCategories = useCallback (async () => {
        
        try {

            const response = await client.getEntries({content_type:'recipeNookTypes'})
            const responseData = response.items
            // console.log(responseData)
            // console.log(response)
            if (responseData) {
                savaCategoryData(responseData)
                setIsCategoriesLoading(true)
            } else {
                setCategories([])
                setIsCategoriesLoading(false)
            }
            
        } 
        catch (error) {
            console.log(error)
            setIsCategoriesLoading(false)
        }
    },[savaCategoryData])

    useEffect(() => {
      fetchCategories()
    }, [fetchCategories])


    
    const contextData = {
       about,
       isAboutLoading,
       isCarouselLoading,
       carouselSlides,
       isCategoriesLoading,
       categories

    }



    return(

        <Context.Provider value={contextData}>
            {props.children}
        </Context.Provider>
    )
}